import { clearLicenseSnapshot } from "@/Utile/licenseHelpers.mjs";
import { clearStoredCompanyContext } from "@/Utile/companyContext.js";
import { clearDealBoardFilterStorage } from "@/Utile/ncrmDealBoardFilters.mjs";
import { clearLeadBoardFilterStorage } from "@/Utile/ncrmLeadBoardFilters.mjs";
import { clearContactsAdvancedFilterStorage } from "@/Utile/ncrmContactsAdvancedFilter.mjs";
import { clearNavContext } from "@/Utile/navigationDrawerContext.mjs";
import { LEGACY_TOKEN_KEY, SESSION_MARKER_KEY } from "@/Utile/authSession.mjs";

export const clearAuthStorage = (storage = globalThis?.localStorage) => {
  if (storage && typeof storage.removeItem === "function") {
    storage.removeItem(SESSION_MARKER_KEY);
    storage.removeItem(LEGACY_TOKEN_KEY);
    storage.removeItem("user-role");
    storage.removeItem("user-roles");
    storage.removeItem("user-primary-role");
    storage.removeItem("user-company-id");
    storage.removeItem("user-company-name");
    storage.removeItem("user-display-name");
    storage.removeItem("user-employee-id");
    storage.removeItem("home-default-redirect-token");
  }
  clearStoredCompanyContext(storage);
  clearDealBoardFilterStorage(storage);
  clearLeadBoardFilterStorage(storage);
  clearContactsAdvancedFilterStorage(storage);
  clearNavContext();
  clearLicenseSnapshot();
};

export const redirectToLoginPage = (browserLocation = globalThis?.location) => {
  if (!browserLocation || typeof browserLocation.replace !== "function") return;
  browserLocation.replace("/login");
};
